import FormatButton from './FormatButton';
import toggleColorMenuIsShown from '../actions/toggleColorMenuIsShown';
import MessageFormatOptionState from '../store/schema/MessageFormatOptionState';
import store from '../store/store';
import { ColorPicker, ColorPickerItem, textColors } from 'owa-color-picker';
import UserOptionsType from 'owa-service/lib/contract/UserOptionsType';
import { getUserConfiguration } from 'owa-session-store';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { reactive } from 'satcheljs/lib/legacy/react';

export interface ColorPickerButtonProps {
    onSelectColor: (color: string) => void;
    optionStore?: MessageFormatOptionState;
    userOptions?: UserOptionsType;
}

@reactive({
    optionStore: () => store,
    userOptions: () => getUserConfiguration().UserOptions,
})
export default class ColorPickerButton extends React.Component<ColorPickerButtonProps, {}> {
    private anchorButton: HTMLElement;

    render() {
        let isShown = this.props.optionStore.isColorMenuShown;

        return (
            <div>
                <FormatButton
                    type="textcolor"
                    isSelected={false}
                    ref={ref => (this.anchorButton = ReactDOM.findDOMNode(ref) as HTMLElement)}
                    onClick={isShown ? this.onDismissMenu : this.onShowMenu}
                />
                {isShown && (
                    <ColorPicker
                        menuTargetElement={this.anchorButton}
                        colors={textColors.get()}
                        onDismissMenu={this.onDismissMenu}
                        onSelectColor={this.onSelectColor}
                        shouldFocusOnMount={true}
                    />
                )}
            </div>
        );
    }

    private onShowMenu() {
        toggleColorMenuIsShown(true);
    }

    private onDismissMenu() {
        toggleColorMenuIsShown(false);
    }

    private onSelectColor = (value: ColorPickerItem) => {
        this.props.onSelectColor(value.code);
    };
}
